export const environment = {
  name: 'dist',
  is_dist: true,
  database_name_suffix: '',
};
